import { render, staticRenderFns } from "./EditProductImage.vue?vue&type=template&id=4e664a7f&scoped=true"
import script from "./EditProductImage.vue?vue&type=script&lang=js"
export * from "./EditProductImage.vue?vue&type=script&lang=js"
import style0 from "./EditProductImage.vue?vue&type=style&index=0&id=4e664a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e664a7f",
  null
  
)

export default component.exports